'use client';

import { styles } from './UiProductInfoVideo.styles';

export interface UiProductInfoVideoProps {
  video?: string;
  className?: string;
}

export function UiProductInfoVideo({
  video,
  className
}: UiProductInfoVideoProps) {
  const slots = styles();

  if (!video) {
    return null;
  }

  return (
    <div
      className={slots.base({
        className: className
      })}
    >
      <div className={slots.wrapper()}>
        <div
          className={slots.video()}
          dangerouslySetInnerHTML={{ __html: video }}
        ></div>
      </div>
    </div>
  );
}
